import { useState, useCallback } from 'react';
import { useLocalMedia } from './useLocalMedia';
import { useLocalMediaActions } from './useLocalMediaActions';
import { useAppSelector } from '../useReduxToolkit';
import { getIsAudioCall } from '../../features/apolloSession/apolloSession.selectors';

type UseRestartCallButtonReturnType = {
  isInProgress: boolean;
  restartMedia: () => Promise<void>;
};
/**
 * To be used for restarting local media with the same options.
 * @TODO Handle media error statuses when they got added.
 * @returns {UseRestartCallButtonReturnType}
 */
export function useRestartLocalMedia(): UseRestartCallButtonReturnType {
  const [isInProgress, setIsInprogress] = useState(false);
  const { hasVideoAccess, hasAudioAccess, hasAudio, hasVideo } =
    useLocalMedia();
  const isAudioCall = useAppSelector(getIsAudioCall);

  const { restart } = useLocalMediaActions();

  const restartMedia = useCallback(async (): Promise<void> => {
    setIsInprogress(true);
    try {
      await restart({
        audio: hasAudioAccess ? hasAudio : true,
        video: hasVideoAccess ? hasVideo : !isAudioCall,
      });
    } finally {
      setIsInprogress(false);
    }
  }, [
    restart,
    hasAudioAccess,
    hasAudio,
    hasVideoAccess,
    hasVideo,
    isAudioCall,
  ]);

  return {
    isInProgress,
    restartMedia,
  };
}
